var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRole = function SvgRole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.8 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 14 4.08 14 5.2 14h5.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C14 12.48 14 11.92 14 10.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C12.48 2 11.92 2 10.8 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#role_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.767 11.205c.074.043.11.065.163.076.04.008.1.008.14 0 .052-.011.089-.033.162-.076.65-.379 2.434-1.569 2.434-3.205V6.406c0-.267 0-.4-.043-.514a.7.7 0 0 0-.182-.263c-.093-.082-.217-.128-.467-.222l-1.787-.67a.7.7 0 0 0-.14-.044.3.3 0 0 0-.095 0 .7.7 0 0 0-.14.044l-1.787.67c-.25.094-.374.14-.466.222a.7.7 0 0 0-.182.263c-.044.114-.044.247-.044.514V8c0 1.636 1.785 2.826 2.434 3.205"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "role_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h8v8H4z"
  })))));
};
export default SvgRole;